import { Link } from 'react-router-dom'

interface LogoProps {
  href?: string
}

export function Logo({ href = '/' }: LogoProps) {
  return (
    <Link to={href} className="flex items-center space-x-2">
      <img src="/logo-2.png" className="w-10 rounded-md" alt="Macro Vendors" />
      <span className="text-lg font-bold text-foreground">Macro Vendors</span>
    </Link>
  )
}
